module.exports = __webpack_public_path__ + "img/icon-cart-outline.490ffa58.svg";